import React, { useState, useEffect } from 'react'
import { Button, Card, CardBody, CardHeader, Col, Row, Spinner } from 'reactstrap'
import { IService } from './index'
import { toast } from 'react-toastify'
import DeleteModal from 'Components/Common/DeleteModal'

interface IProps {
  fetching: boolean
  serviceRecords: IService[]
  handleOpenDetails: (arg: string) => void
  setOpenServicePopup: (arg: boolean) => void
  setEditMode: (arg: boolean) => void
  handleDeleteService: (arg: string) => Promise<string>
  setCanEdit: (arg: boolean) => void
  onReorder: (id: string, direction: 'up' | 'down') => void
}

const ServicesTable: React.FC<IProps> = ({
  serviceRecords,
  handleOpenDetails,
  setOpenServicePopup,
  setEditMode,
  fetching,
  handleDeleteService,
  setCanEdit,
  onReorder
}) => {
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined)
  // 🔒 2026-08-17: varsayilan FAIL-CLOSED olmali. Eskiden `true` ile
  // basliyordu; asagidaki useEffect yalnizca yetki listesinde BU sayfa
  // bulunursa deger yaziyor. Yani operatorun bu sayfada hic yetkisi yoksa
  // (ya da oturum verisi bozuksa) baslangic degeri KALIYOR ve tum
  // Ekle/Duzenle/Sil dugmeleri ACIK gorunuyordu.
  // Adminler asagidaki `userType === '1'` daliyla ayrica ele aliniyor.
  const [permissions, setPermissions] = useState({
    canCreate: false,
    canEdit: false,
    canDelete: false
  })

  const handleAdd = () => {
    setEditMode(false)
    setOpenServicePopup(true)
  }

  const handleEdit = (id: string | undefined) => {
    setEditMode(true)
    setOpenServicePopup(true)
    handleOpenDetails(id as string)
  }

  const handleDeleteRecord = async (id: string | undefined) => {
    const message = await handleDeleteService(id as string)
    if (message === 'SUCCESSFULL') {
      toast.success('Deleted service successfully')
    }
  }

  const handleShowModalDelete = (id: string | undefined) => {
    setShowModalDelete(true)
    setSelectedId(id)
  }

  const handleDelete = () => {
    handleDeleteRecord(selectedId)
    setShowModalDelete(false)
  }

  useEffect(() => {
    const userType = sessionStorage.getItem('userType')
    if (userType === '1') {
      setPermissions({ canCreate: true, canEdit: true, canDelete: true })
      setCanEdit(true)
      return
    }

    const userRoles = sessionStorage.getItem('userRoles')
      ? JSON.parse(atob(sessionStorage.getItem('userRoles')!))
      : null
    if (userRoles) {
      userRoles.forEach((role: any) => {
        if (role.page === 'Services') {
          setPermissions({
            canCreate: role.canCreate,
            canEdit: role.canEdit,
            canDelete: role.canDelete
          })
          setCanEdit(role.canEdit)
        }
      })
    }
  }, [setCanEdit])

  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader className='align-items-center d-flex justify-content-between'>
              <h5 className='mb-0'>Services</h5>
              {permissions.canCreate && (
                <Button className='p-2' color='primary' onClick={handleAdd}>
                  <div className='flex align-items-center'>
                    {fetching ? (
                      <Spinner size='sm'> Loading... </Spinner>
                    ) : (
                      <>
                        <i className='mdi mdi-plus'></i>
                        <span className='fw-semibold ms-1'>New Service</span>
                      </>
                    )}
                  </div>
                </Button>
              )}
            </CardHeader>
            <CardBody>
              <div className='table-responsive table-card'>
                <table className='table align-middle table-nowrap table-striped-columns mb-0'>
                  <thead className='table-light'>
                    <tr>
                      <th scope='col' style={{ width: '80px', textAlign: 'center' }}>Order</th>
                      <th scope='col'>Name</th>
                      <th scope='col'>Label</th>
                      <th scope='col'>Price</th>
                      <th scope='col' style={{ textAlign: 'center' }}>Active</th>
                      <th scope='col' style={{ width: '150px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {serviceRecords.map((service, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: 'center' }}>
                          <div className='d-flex align-items-center justify-content-center gap-1'>
                            <button
                              className='btn btn-sm btn-soft-secondary p-0 px-1'
                              disabled={index === 0}
                              onClick={() => onReorder(service._id!, 'up')}
                              title='Move up'
                            >
                              <i className='ri-arrow-up-s-line'></i>
                            </button>
                            <span className='fw-medium'>{index + 1}</span>
                            <button
                              className='btn btn-sm btn-soft-secondary p-0 px-1'
                              disabled={index === serviceRecords.length - 1}
                              onClick={() => onReorder(service._id!, 'down')}
                              title='Move down'
                            >
                              <i className='ri-arrow-down-s-line'></i>
                            </button>
                          </div>
                        </td>
                        <td>{service.name}</td>
                        <td>{service.label}</td>
                        <td>{service.price}</td>
                        <td style={{ textAlign: 'center' }}>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={service.isActive || false}
                            disabled
                          />
                        </td>
                        <td>
                          <button
                            type='button'
                            className='btn btn-sm btn-light'
                            onClick={() => handleEdit(service._id)}
                          >
                            Details
                          </button>
                          {permissions.canDelete && (
                            <button
                              type='button'
                              className='btn btn-sm btn-danger ms-2'
                              onClick={() => handleShowModalDelete(service._id)}
                            >
                              Delete
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <DeleteModal
        show={showModalDelete}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowModalDelete(false)}
      />
    </React.Fragment>
  )
}
export default ServicesTable
